export function productRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_PRODUCT_START":           
        case "DUPLICATE_PRODUCT_START":           
        case "UPDATE_PRODUCT_START":           
        case "ADD_PHOTOS_PRODUCT_START":           
        case "UPDATE_PHOTOS_PRODUCT_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_PRODUCT_FULFILLED":           
        case "DUPLICATE_PRODUCT_FULFILLED":           
        case "UPDATE_PRODUCT_FULFILLED":           
        case "ADD_PHOTOS_PRODUCT_FULFILLED":           
        case "UPDATE_PHOTOS_PRODUCT_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_PRODUCT_ERROR":
        case "DUPLICATE_PRODUCT_ERROR":
        case "UPDATE_PRODUCT_ERROR":
        case "ADD_PHOTOS_PRODUCT_ERROR":
        case "UPDATE_PHOTOS_PRODUCT_ERROR":
            console.log('ProductRequest reducer - Error action received:', type, 'payload:', payload);
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        case "RESET_PRODUCT_STATE":
            return {
                fetching:false,
                fetched: false,
                error:null,
            }
        default:
            return state;
    }
    
}